const zh={
    login:{
        title:'数据提报系统',
        email:'电子邮件',
        password:'密码',
        forgotPassword:"忘记密码",
        logout:"退出",
        inEmail:'邮箱错误',
        loginfailed:'登录失败，邮箱或密码错误',
        enterEmail:'请输入邮箱',
        enterPassword:'请输入密码',
        enterCode:'请输入验证码',
        passwordNotMatch:'密码不匹配',	
    },
    forgot:{
        forgotPassword:"忘记密码",
        tip:"我们会给你发一个验证码给你的电子邮箱",
        email:'电子邮件',
        code:"验证码",
        password:'密码',
        confirmPassword:"确认密码",
        send:"发送",
        submit:"提交",
        login:"登录",
    },
    menu:{
        mange:"表单管理",
        mangeTip:"数据提报表单的创建、数据查看",

        submission:"表单填报",
        account:"账号管理",
        uwell:"内部账号",
        external:"外部账号"
    },
    editList:{
        fill:"填写",
        record:"数据",
        createdTime:"创建时间",
        formTitle:"表单名称",
        titleTip:"请输入标题",
        showInput:"为你展示待填写的表单和填写记录"
    },
    editFill:{
        save:'保存',
        nosave:'不保存',
        backSaveTip:'是否保存已填写内容？',
        submitted:'已提交',
        notsubmitted:'未提交',

        submit:"提交",
        submitSuccess:"提交成功",
        fillAgain:"再次填写",
        
        invalid:"参数有误",
        noTime:"表单不在有效期内，不可填写",
        failedStop:"提交失败，表单已停止采集",
        failedNot:"提交失败，表单不存在",
        failedPassed:"提交失败，表单仅可填写一次",
        failedOnce:"提交失败，表单每日仅可填写一次",
        noempty:"必填项不能为空"
    },
    editInfo:{
        SubmitTime:"提交时间",
        submitter:'提交用户',
        search:"搜索",
        clear:"重置",
        filter:"筛选",
        fieldSetting:"字段管理",
        export:"导出",
        createBy:"创建人",
        updateTime:"更新时间",
        status:'状态',
        action:"操作",
        detail:"查看",
        edit:"修改",
        more:"更多",
        copy:"复制",
        startDate:"开始日期",
        endDate:"结束日期",
        selectAll:"全选",
        confirm:"确定",
        cancel:"取消",
        addFilter:"添加筛选条件",
        pleaseSelect:"请选择",
        pleaseFillIn:"请填写",
        delete:"删除",
        filterIncom:`第 {num} 行筛选条件不完整，请确认`,
        noData:"暂无数据",
        uploadfailed:'上传失败',
        total:`共 {num} 条`,

        deleteTip:'此操作将删除该数据, 是否继续?',
        deleteSuccess:'删除成功'
    },
    fillIn:{
        equal:'等于',
        noequal:'不等于',
        contains:'包含',
        notcontains:'不包含',
        empty:'空',
        notempty:'非空',
        before:'早于',
        after:'晚于',
        greaterequal:'大于等于',
        lessequal:'小于等于',
        greaterthan:'大于',
        lessthan:'小于',
    },
    editEye:{
        detail:"表单数据"
    },
    editUpdate:{
        editForm:"表单修改",
        returnList:"返回列表"
    }
}

export default zh;